export default __webpack_public_path__ + "static/logo-esto-de45e3217ccd7d2a5cbd9f547d7ff6d7.png";